import React, { PureComponent } from 'react';
import DocumentTitle from 'react-document-title';
import * as EmailValidator from 'email-validator';

import FieldDefault from './field-default';
import GoogleLogin from './google-login';

export default class Login extends PureComponent {
    static defaultProps = {
        email: ''
    };

    constructor(props) {
        super(props);

        this.state = {
            email: this.props.email,
            password: '',
            loading: false,
            sso: false
        }

        this.handleKeyDown = this.handleKeyDown.bind(this);
    }

    handleEmailChange = (value) => {
        this.setState({
            email: value
        });
    }

    handlePasswordChange = (value) => {
        this.setState({
            password: value
        });
    }

    handleSuccessClick = () => {
        this.submit()
    }

    handleForgottenPasswordClick = () => {
        this.props.onForgottenPasswordClick(this.state.email);
    }

    handleSignupClick = () => {
        this.props.onSignupClick(this.state.email);
    }

    submit() {
        this.setState({
            loading: true
        });

        this.props.onSuccess && this.props.onSuccess({
            email: this.state.email,
            password: this.state.password
        })
            .catch(() => {
                this.setState({
                    loading: false
                });
            });
    }

    handleKeyDown(event) {
        if (event.which === 13) {
            this.submit();
        }
    }

    handleGoogleLoginSuccess = response => {
        this.setState({
            loading: true,
            ssoLoading: true
        });

        this.props.onSuccess && this.props.onSuccess({
            provider: 'google',
            socialData: {
                googleId: response.googleId,
                tokenId: response.tokenId,
                profileObj: response.profileObj
            }
        })
            .catch(() => {
                this.setState({
                    loading: false,
                    ssoLoading: false
                });
            });
    }

    get populated() {
        return this.state.email !== '' && this.state.password !== '' && EmailValidator.validate(this.state.email);
    }

    componentDidMount() {
        window.addEventListener('keydown', this.handleKeyDown);
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleKeyDown);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.email !== this.props.email && this.props.email !== this.state.email) {
            this.setState({
                email: this.props.email
            });
        }
    } 

    render() {
        return (
            <DocumentTitle title={`Login | Nifty`}>
                <div className="section-login">
                    <div className="section-head">
                        <h1>Log in to your account</h1>
                    </div>

                    <div className="section-body">
                        <div className="form">
                            <div className="form-row">
                                <FieldDefault id="login-email" type="email" label="Email address" value={this.state.email} onChange={this.handleEmailChange} required={true} placeholder="name@company.com" />
                            </div>

                            <div className="form-row">
                                <FieldDefault id="login-password" type="password" label="Password" value={this.state.password} onChange={this.handlePasswordChange} required={true} placeholder="Password">
                                    <span className="field-helper" onClick={this.handleForgottenPasswordClick} tabIndex="-1">Forgot password?</span>
                                </FieldDefault>
                            </div>
                        </div>
                    </div>

                    <div className="section-foot">
                        <button
                            id="login-submit"
                            className={'btn btn-block btn-success btn-has-loading' + (this.state.loading && !this.state.ssoLoading ? ' loading' : '')}
                            disabled={!this.populated}
                            onClick={this.handleSuccessClick}
                        >Log in</button>
                    </div>

                    <div className="section-foot centered">
                        <GoogleLogin
                            className={'btn btn-link btn-text-caution btn-has-loading' + (this.state.loading && this.state.ssoLoading ? ' loading' : '')}
                            onSuccess={this.handleGoogleLoginSuccess}
                        />
                    </div>

                    <div className="section-cta">
                        <div className="section-divider"><span>OR</span></div>

                        <p>Don’t have an account?</p>

                        <button className="btn btn-secondary btn-text-caution" id="btn-signup" onClick={this.handleSignupClick}>Sign up for free</button>
                    </div>
                </div>
            </DocumentTitle>
        );
    }
}
